export default {
  Success: 1,
  Error_TOKEN_EXPIRED: '_00027',
  Error_USER_LOGGED_OUT_ALREADY: '_00062',
  ERROR_NO_EMAIL_TO_RESET_PASSWORD_PIN: '_00411',
  Error_ACCOUNT_LOCKED: '_00065',
  Error_AUDIT_ALREADY_BEEN_CLOSED: '_00814',
  Error_USER_ROLE_COULDNT_BE_IDENTIFIED: '_00815',
  Error_NC_ALREADY_RESOLVED: '_00816',
  Error_ACCOUNT_DISABLED: '_00031',
  Error_INSTANCE_ALREADY_EXISTS: '_00045',
  Error_USER_ALREADY_EXIST: '_00003',
  Error_UNABLE_TO_AUTHENTICATE: '_00023',
};
